<template>
    <div class="cancel-account-success">
        <svg-icon icon-class="appoint-scs" class-name="appoint-scs"></svg-icon>
        <div class="t1">{{$t('logout.LogoutSucc')}}</div>
        <div class="t2">{{$t('logout.NotProvideService')}}</div>
        <BasicBtnGroup
            :showDef="false"
            @primeClick="$emit('cancelComplete')"
            class="success-confirm-btn"
        >
            <span slot="primaryContent">{{$t('common.Ok')}}</span>
        </BasicBtnGroup>
    </div>
</template>
<script>
import BasicBtnGroup from '@/components/behavior/basic-btn-group/index.vue'

export default {
  name: 'CancelAccountSuccess',
  components: {
    BasicBtnGroup
  }
}
</script>
<style scoped lang="less">
.cancel-account-success {
    position: relative;
    height: 100%;
    padding: 0 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .appoint-scs {
        width: 88px;
        height: 88px;
        margin-top: 28px;
    }
    .t1 {
        font-size: 28px;
        font-weight: 600;
        color: #333333;
        margin: 32px 0 24px 0;
    }
    .t2 {
        font-size: 16px;
        font-weight: 400;
        color: #6A6D73;
    }
    .success-confirm-btn {
        position: absolute;
        right: 56px;
        bottom: 48px;
        ::v-deep .ant-btn {
            padding: 10px 48px;
        }
    }
}
</style>
